<script setup>

import HeaderMobile from './header.vue'
import ContentMobile from './content.vue'
// import FooterMobile from '@/components/common/cellphone-footer.vue'
import { onMounted } from 'vue'
import { addShareNum } from '@/api/2025/index.js'
import { URLparams } from '@/utils/help.js'

const id = URLparams.get('secret')

onMounted (() => {
    if(id){
        addShareNum(id)
    }
})

</script>

<template>
    <HeaderMobile />
    <ContentMobile />
    <FooterMobile />
</template>
<style lang="scss" scoped>
</style>
